export const VserverGraphic = {
  cores:"/static/icons/icons8-smartphone_cpu.svg",
  memory:"/static/icons/icons8-memory_slot.svg",
  disk:"/static/icons/icons8-ssd.svg"
}



// WEBPACK FOOTER //
// ./src/mixins/vserver_graphic.js